/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_About_HeadlineInputs */

const en_label_about_headline = /** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Headline`)
};

const es_label_about_headline = /** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titular del Negocio`)
};

const fr_label_about_headline = /** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre de l'entreprise`)
};

const de_label_about_headline = /** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschäftsüberschrift`)
};

const id_label_about_headline = /** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul Bisnis`)
};

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const ja_label_about_headline = en_label_about_headline;

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const zh_label_about_headline = en_label_about_headline;

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const ar_label_about_headline = en_label_about_headline;

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const it_label_about_headline = en_label_about_headline;

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const ru_label_about_headline = en_label_about_headline;

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const pt_label_about_headline = en_label_about_headline;

/** @type {(inputs: Label_About_HeadlineInputs) => LocalizedString} */
const ko_label_about_headline = en_label_about_headline;

/**
* | output |
* | --- |
* | "Business Headline" |
*
* @param {Label_About_HeadlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_about_headline = /** @type {((inputs?: Label_About_HeadlineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_About_HeadlineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_about_headline(inputs)
	if (locale === "es") return es_label_about_headline(inputs)
	if (locale === "fr") return fr_label_about_headline(inputs)
	if (locale === "de") return de_label_about_headline(inputs)
	if (locale === "ja") return ja_label_about_headline(inputs)
	if (locale === "zh") return zh_label_about_headline(inputs)
	if (locale === "ar") return ar_label_about_headline(inputs)
	if (locale === "id") return id_label_about_headline(inputs)
	if (locale === "it") return it_label_about_headline(inputs)
	if (locale === "ru") return ru_label_about_headline(inputs)
	if (locale === "pt") return pt_label_about_headline(inputs)
	return ko_label_about_headline(inputs)
});